import { createAction, props } from '@ngrx/store';
import { LookupValue, PigSigLookup } from 'src/app/models/lookup.model';
import { menuDataType, PigSigProduct, SpareParts, PigSigWallThickness, PigSigFlangeHeight } from 'src/app/models/pig-sig-selector.model';
import { Loaders, PigSigFilter, PigSigLookups, PigSigQueryResult } from '../fromPigSig.barrel';

const prefix = '[PIGSIG]';

export const loadLookups = createAction(`${prefix} load lookups`);
export const loadLookupsSuccess = createAction(`${prefix} load lookups success`, props<{
  indicators: PigSigLookup[],
  shafts: PigSigLookup[],
  plugs: PigSigLookup[],
  orings: PigSigLookup[],
  connections: PigSigLookup[],
  flangeMatls: PigSigLookup[],
  diameters: PigSigLookup[],
  thicknesses: PigSigLookup[]
}>());

export const loadLookupsFail = createAction(`${prefix} load lookups fail`, props<{ error: any }>());

export const loadIndicators = createAction('[PigSig] Load Indicators');
export const loadIndicatorsSuccess = createAction('[PigSig] Load Indicators Success', props<{ indicators: PigSigLookup[] }>());
export const loadIndicatorsFail = createAction('[PigSig] Load Indicators fail', props<{ error: any }>());

export const loadShafts = createAction('[PigSig] Load Shafts');
export const loadShaftsSuccess = createAction('[PigSig] Load Shafts Success', props<{ shafts: PigSigLookup[] }>());
export const loadShaftsFail = createAction('[PigSig] Load Shafts fail', props<{ error: any }>());

export const loadPlugs = createAction('[PigSig] Load Plugs');
export const loadPlugsSuccess = createAction('[PigSig] Load Plugs Success', props<{ plugs: PigSigLookup[] }>());
export const loadPlugsFail = createAction('[PigSig] Load Plugs fail', props<{ error: any }>());

export const loadOrings = createAction('[PigSig] Load Orings');
export const loadOringsSuccess = createAction('[PigSig] Load Orings Success', props<{ orings: PigSigLookup[] }>());
export const loadOringsFail = createAction('[PigSig] Load Orings fail', props<{ error: any }>());

export const loadConnections = createAction('[PigSig] Load Connections');
export const loadConnectionsSuccess = createAction('[PigSig] Load Connections Success', props<{ connections: PigSigLookup[] }>());
export const loadConnectionsFail = createAction('[PigSig] Load Connections fail', props<{ error: any }>());

export const loadFlangeMatls = createAction('[PigSig] Load FlangeMatls');
export const loadFlangeMatlsSuccess = createAction('[PigSig] Load FlangeMatls Success', props<{ flangeMatls: PigSigLookup[] }>());
export const loadFlangeMatlsFail = createAction('[PigSig] Load FlangeMatls fail', props<{ error: any }>());

export const loadSpareParts = createAction('[PigSig] Load SpareParts');
export const loadSparePartsSuccess = createAction('[PigSig] Load SpareParts Success', props<{ spareParts: SpareParts[] }>());
export const loadSparePartsFail = createAction('[PigSig] Load SpareParts fail', props<{ error: any }>());

export const loadPigSigResults = createAction('[PigSig] Load PigSigResults');
export const loadPigSigResultsSuccess = createAction('[PigSig] Load PigSigResults Success', props<{ pigSigResults: PigSigQueryResult }>());
export const loadPigSigResultsFail = createAction('[PigSig] Load PigSigResults fail', props<{ error: any }>());

export const loadFlangeHeightsSuccess = createAction('[PigSig] load flange heights success', props<{ flangeHeights: PigSigFlangeHeight[] }>());
export const loadFlangeHeightsFail = createAction('[PigSig] load flange heights fail', props<{ error: any }>());

export const loadFlangePartNumber = createAction('[PigSig] Load FlangePartNumber');
export const loadFlangePartNumberSuccess = createAction('[PigSig] Load FlangePartNumber Success', props<{ value: string }>());
export const loadFlangePartNumberFail = createAction('[PigSig] Load FlangePartNumber fail', props<{ error: any }>());

export const loadDiameters = createAction('[PigSig] Load Diameters');
export const loadDiametersSuccess = createAction('[PigSig] Load Diameters Success', props<{ diameters: PigSigLookup[] }>());
export const loadDiametersFail = createAction('[PigSig] Load Diameters fail', props<{ error: any }>());

export const loadThicknesses = createAction('[PigSig] Load Thicknesses');
export const loadThicknessesSuccess = createAction('[PigSig] Load Thicknesses Success', props<{ wallThicknesses: PigSigWallThickness[] }>());
export const loadThicknessesFail = createAction('[PigSig] Load Thicknesses fail', props<{ error: any }>());

export const activateIndicator = createAction(`${prefix} activate indicator`, props<{ val?: number }>());

export const clearPigSigFilter = createAction(`${prefix} clear pigsig filter`);
export const updatePigSigFilter = createAction(`${prefix} active pigsig filter`, props<{ value: Partial<PigSigFilter> }>());
export const updatePigSigLookups = createAction(`${prefix} update pigsig lookups`, props<{ value: Partial<PigSigLookups> }>())

export const updateFlangeHeightChange = createAction(`${prefix} update flange height change`, props<{ val?: number }>());
export const activatePartNumber = createAction(`${prefix} activate partnumber`, props<{ partnumber: string }>());
//---------
export const resetActiveIndicator = createAction('[PigSig] Reset active indicator');
export const setActiveIndicator = createAction('[PigSig] Set Active Indicator', props<{ active: menuDataType }>())
export const setIndicatorVal = createAction('[PigSig] set indicator val', props<{ value: string }>());
export const setShaftVal = createAction('[PigSig] set Shaft val', props<{ value: string }>());
export const setPlugVal = createAction('[PigSig] set Plug val', props<{ value: string }>());
export const setOringVal = createAction('[PigSig] set Oring val', props<{ value: string }>());
export const setConnectionVal = createAction('[PigSig] set Connection val', props<{ value: string }>());
export const setFlangeMatlVal = createAction('[PigSig] set FlangeMatl val', props<{ value: string }>());
export const setDiameterVal = createAction('[PigSig] set Diameter val', props<{ value: string }>());
export const setThicknessVal = createAction('[PigSig] set Thickness value', props<{ value: string }>());
export const setFlangeRatingVal = createAction('[PigSig] set Flange Rating Value', props<{ value: string }>());
export const setFlangeFaceVal = createAction('[PigSig] set Flange Face Value', props<{ value: string }>());
export const setActivePigSig = createAction('[PigSig] set active Pig-Sig', props<{ value: PigSigProduct }>());
export const resetActivePigSig = createAction('[PigSig] Reset active Pig-Sig');
export const setEnclosure = createAction('[PigSig] Set Enclosure', props<{ value: boolean }>());
export const setLessNipple = createAction('[PigSig] Set LessNipple', props<{ value: boolean }>());
export const setPigSigPartNumber = createAction('[PigSig] set PigSig Part Number', props<{ value: string }>());
export const resetPigSigPartNumber = createAction('[PigSig] reset PigSig Part Number');

export const setDiameterId = createAction('[PigSig] set Diameter Id', props<{ value: number }>());
export const setpipeWallThickness = createAction('[PigSig] set pipeWallThickness', props<{ value: number }>());
export const setflangeHeight = createAction('[PigSig] set flangeHeight', props<{ value: number }>());
export const setgasketThickness = createAction('[PigSig] set gasketThickness', props<{ value: number }>());

export const removeLoader = createAction(`${prefix} remove loader`, props<{ loader: Loaders }>());

export const loadDwg = createAction(`${prefix} load dwg`, props<{ filename: string }>());
export const loadDwgSuccess = createAction(`${prefix} load dwg success`);
export const loadDwgFail = createAction(`${prefix} load dwg fail`, props<{ error: any }>());
